// extracted by mini-css-extract-plugin
export default {"editable":"exercise_editable__wU0AE"};